var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Cartographic, Ellipsoid } from '@skand/math';
import Papa from 'papaparse';
import { Vector3 } from '@skand/math';
import proj4 from 'proj4';
class EsriCsvLoader {
    /**
     * Convert a position in some coordinate system to ECEF
     *
     * @param x          x-position in source coordinate system
     * @param y          y-position in source coordinate system
     * @param z          z-position in source coordinate system
     * @param projection Projection string of source coordinate system
     */
    calculatePosition(x, y, z, projection) {
        if (!projection) {
            return new Vector3(x, y, z);
        }
        try {
            const ecefSpace = proj4(projection, 'EPSG:4326').forward({ x, y, z });
            return Ellipsoid.WGS_84.cartesianForCartographic(new Cartographic((ecefSpace.x * Math.PI) / 180, (ecefSpace.y * Math.PI) / 180, ecefSpace.z));
        }
        catch (error) {
            throw new Error(`Invalid Projection Error: ${error}`);
        }
    }
    /**
     * Find relevant column indexes by name
     *
     * @param array
     * @param substring
     */
    findColumnIndex(array, substring) {
        const indexes = [];
        for (let i = 0; i < array.length; i++) {
            if (array[i].includes(substring)) {
                indexes.push(i);
            }
        }
        return indexes; // returns array of indexes e.g [0,5]
    }
    /**
     * Find name column index
     *
     * @param array
     * @param substring
     */
    findNameColumnIndex(array, substring) {
        const indexes = [];
        for (let i = 0; i < array.length; i++) {
            if (array[i].toLowerCase().includes(substring)) {
                indexes.push(i);
            }
        }
        return indexes; // returns array of indexes e.g [0,5]
    }
    /**
     * Get list of annotations
     *
     * @param csv csv string
     * @param templateFields template fields array
     * @param projection projection string of source coordinate system
     */
    read(csv, templateFields, projection) {
        return __awaiter(this, void 0, void 0, function* () {
            const annotations = [];
            const parsed = Papa.parse(csv, {
                header: false,
                delimitersToGuess: [','],
                skipEmptyLines: true,
            });
            // Get column names (column names are provide column index and names)
            const headerRow = parsed.data[0];
            for (let i = 0; i < parsed.data.length; i++) {
                if (i == 0)
                    continue;
                const values = Object.values(parsed.data[i]);
                const x = parseFloat(values[this.findColumnIndex(headerRow, 'X')[0]]);
                const y = parseFloat(values[this.findColumnIndex(headerRow, 'Y')[0]]);
                const z = parseFloat(values[this.findColumnIndex(headerRow, 'Z')[0]]);
                const name = values[this.findNameColumnIndex(headerRow, 'name')[0]];
                const annotationFields = [];
                for (const tempfield of templateFields) {
                    const value = values[this.findColumnIndex(headerRow, tempfield.name)[0]];
                    if (headerRow.includes(tempfield.name)) {
                        const field = {
                            name: tempfield.name,
                            type: tempfield.type,
                            value: value,
                        };
                        annotationFields.push(field);
                    }
                }
                annotations.push({
                    name: name ? name : `Annotation-${i}`,
                    color: '#FFFFFF',
                    annotation3d: {
                        positions: [this.calculatePosition(x, y, z, projection)],
                        shapeType: 'POINT',
                    },
                    fields: annotationFields,
                });
            }
            return annotations;
        });
    }
}
export default EsriCsvLoader;
